// extracted by mini-css-extract-plugin
export default {"gameContainerMarginTop":"14vh","gameContainerMarginLeft":"9vw"};